import React, { useState, useEffect } from 'react';

import { makeStyles } from '@mui/styles';

import CloseIcon from '@mui/icons-material/Close';

import CommonStyles from './CommonStyles';
import TrplSelect from './TrplControls/TrplSelect';
import AutocompleteSelect from './AutocompleteSelect';

const useStyles = makeStyles({
  popoverContent: {
    padding: '10px',
    minWidth: '320px',
  },
  emptySortersText: {
    color: '#C4C4C4',
  },
  sorterRow: {
    display: 'flex',
    alignItems: 'center',
  },
  sortersBtn: {
    flexShrink: '0',
    color: '#4E4C4C',
    display: 'flex',
    fontSize: '12px',
    borderRadius: '4px',
    padding: '1px 10px 4px 10px',
    '&:hover': {
      cursor: 'pointer',
      background: '#DBD9E7',
    },
  },
  sortersBtnSelected: {
    background: '#eeecf8',
    border: '1px #D9D8ED solid',
  },
  addNewSorter: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
  },
  addSorterSortBy: {
    width: '150px',
    display: 'flex',
    flexShrink: '0',
    alignItems: 'center',
  },
  addSorterSelect: {
    '& .autocomplete-placeholder': {
      color: '#878787',
      fontSize: '12px',
      fontStyle: 'italic',
    },
  },
  sortBySelectLabel: {
    display: 'flex',
    flexShrink: '0',
    color: '#4E4C4C',
    marginRight: '10px',
  },
  ...CommonStyles,
});

export default ({ rstDataMap, initialSorters, callbacks }) => {
  const classes = useStyles();

  const [sortBy, setSortBy] = useState(1);
  const [sorters, setSorters] = useState([]);
  const [addSorterValues, setAddSorterValues] = useState([]);
  const [selectedSorterValues, setSelectedSorterValues] = useState([]);

  useEffect(() => {
    const addSorterValuesCopy = [];
    const selectedSorterValuesCopy = [];

    for (const rst of rstDataMap.values()) {
      if (rst.type === 'BUTTON') continue;

      const chainTitle = rst.chainTitle ? rst.chainTitle : rst.id;
      const title = rst.complicated_title ? rst.complicated_title : rst.title;

      const value = { label: `${title + ' [' + chainTitle + ']'}`, value: chainTitle };

      addSorterValuesCopy.push(value);
      selectedSorterValuesCopy.push({
        title: value.label,
        value: value.value,
      });
    }

    if (initialSorters && initialSorters.sort_pid) {
      setSorters([
        {
          sortBy: initialSorters.sort_by || 0,
          value: initialSorters.sort_pid,
          sortDesc: initialSorters.sort_desc === 'false' || !initialSorters.sort_desc ? false : true,
        },
      ]);
    }

    setAddSorterValues(addSorterValuesCopy);
    setSelectedSorterValues(selectedSorterValuesCopy);
  }, []);

  const removeSorter = (index) => {
    const sortersCopy = [...sorters];

    sortersCopy.splice(index, 1);

    setSorters(sortersCopy);

    if (callbacks.setSorters)
      callbacks.setSorters({
        sort_desc: false,
        sort_pid: '',
        sort_by: 0,
      });
  };

  const addSorter = (rstId) => {
    const newSorter = {
      value: rstId,
      sortBy,
    };

    setSorters((prevSorters) => [...prevSorters, newSorter]);
  };

  const changeSorterField = (index, key, value) => {
    const sortersCopy = [...sorters];

    const sorter = { ...sortersCopy[index] };

    if (key === 'value' || key === 'sortBy') {
      sorter['sortDesc'] = null;
    }

    sorter[key] = value;

    sortersCopy[index] = sorter;

    setSorters(sortersCopy);
  };

  return (
    <div className={classes.popoverContent}>
      {!sorters.length ? (
        <div className={classes.emptySortersText}>No sorters applied to this view</div>
      ) : (
        sorters.map((sorter, sorterIndex) => {
          return (
            <div key={sorterIndex} className={classes.sorterRow}>
              <CloseIcon
                className={classes.pointer}
                style={{
                  fontSize: '17px',
                  color: '#878787',
                  marginRight: '20px',
                }}
                onClick={() => removeSorter(sorterIndex)}
              />

              <div
                style={{
                  width: '260px',
                  marginRight: '10px',
                  flexShrink: '0',
                }}
              >
                <TrplSelect
                  margin="none"
                  value={sorter.value}
                  complicatedValues
                  values={selectedSorterValues}
                  onChange={(e) => changeSorterField(sorterIndex, 'value', e.target.value)}
                />
              </div>

              <div className={classes.addSorterSortBy}>
                <span className={classes.sortBySelectLabel}>Sort by</span>

                <TrplSelect
                  fullWidth
                  margin="none"
                  complicatedValues
                  value={sorter.sortBy === 0 ? '0' : '1'}
                  values={[
                    { title: 'Value', value: 1 },
                    { title: 'Update time', value: 0 },
                  ]}
                  onChange={(e) => {
                    changeSorterField(sorterIndex, 'sortBy', e.target.value);
                  }}
                />
              </div>

              <div
                onClick={() => {
                  changeSorterField(sorterIndex, 'sortDesc', false);

                  if (callbacks.setSorters)
                    callbacks.setSorters({
                      sort_desc: false,
                      sort_pid: sorter.value,
                      sort_by: sorter.sortBy,
                    });
                }}
                className={`${classes.ml10} ${classes.sortersBtn} ${classes.mr10} ${
                  sorter.sortDesc === false ? classes.sortersBtnSelected : ''
                }`}
              >
                A - Z
              </div>

              <div
                onClick={() => {
                  changeSorterField(sorterIndex, 'sortDesc', true);

                  if (callbacks.setSorters)
                    callbacks.setSorters({
                      sort_desc: true,
                      sort_pid: sorter.value,
                      sort_by: sorter.sortBy,
                    });
                }}
                className={`${classes.sortersBtn} ${sorter.sortDesc === true ? classes.sortersBtnSelected : ''}`}
              >
                Z - A
              </div>
            </div>
          );
        })
      )}

      {!sorters.length ? (
        <div className={classes.addNewSorter}>
          <div
            style={{
              width: '260px',
              flexShrink: '0',
              marginRight: '10px',
            }}
          >
            <AutocompleteSelect
              value={''}
              options={addSorterValues}
              placeholder="Column to sort by"
              className={classes.addSorterSelect}
              onChange={(option) => {
                addSorter(option.value);
                if (callbacks.onAddInitialRst) callbacks.onAddInitialRst();
              }}
            />
          </div>

          <div className={classes.addSorterSortBy}>
            <span className={classes.sortBySelectLabel}>Sort by</span>

            <TrplSelect
              fullWidth
              margin="none"
              complicatedValues
              value={sortBy}
              values={[
                { title: 'Value', value: 1 },
                { title: 'Update time', value: 0 },
              ]}
              onChange={(e) => {
                setSortBy(e.target.value);
              }}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};
